module.exports = __webpack_public_path__ + "img/podium_2131.cf4afa23.jpg";